import React, { useEffect, useState } from 'react';

import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';

import Register from '../../components/register/Register';
import ValidationException from '../../exceptions/ValidationException';
import useBlocRef from '../../utils/useBlocRef.hook';

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  event: 'pageview',
  page: {
    title: 'register',
    url: '/register',
  },
});

export default () => {
  const blocRef = useBlocRef('registerBloc');
  const history = useHistory();
  const [validationErrors, setValidationErrors] = useState(null);
  const [registerValues, setRegisterValues] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const registerValuesSub = blocRef.current.values$.subscribe(setRegisterValues);
    return () => {
      registerValuesSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeValues = (data, target) => blocRef.current.onValuesChange(data, target);

  const register = async (data) => {
    try {
      await blocRef.current.register(data);
      history.push('/auth-success?action=register');
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      } else {
        enqueueSnackbar(exception.message, { autoHideDuration: 10000, variant: 'error' });
      }
    }
  };

  return <Register isRegistering$={blocRef.current.isRegistering$} onRegister={register} values={registerValues} onChangeValues={handleChangeValues} errors={validationErrors} />;
};
